import { revitBufferParamsAPI } from "./api";

export const getRevitBufferParamsList = async (params) => {
  try {
    const res = await revitBufferParamsAPI.getRevitBufferParamsList(params);
    return {
      data: res?.data?.map((item, i) => ({ ...item, index: i + 1 })) || [],
      totals: {
        total_count: res?.total_count,
        total_volume: res?.total_volume,
        total_area: res?.total_area,
      },
    };
  } catch (e) {
    return { data: [], totals: {} };
  }
};

export const getFloorField1 = async (params) => {
  try {
    const res = await revitBufferParamsAPI.getFloorField1(params);
    return (
      res?.data?.map((item) => ({
        value: item.floor_field_1,
        label: item.floor_field_1,
      })) || []
    );
  } catch (e) {
    return [];
  }
};

export const getFloorField2 = async (params) => {
  try {
    const res = await revitBufferParamsAPI.getFloorField2(params);
    return (
      res?.data?.map((item) => ({
        value: item.floor_field_2,
        label: item.floor_field_2,
      })) || []
    );
  } catch (e) {
    return [];
  }
};

export const getWallTypes = async (params) => {
  try {
    const res = await revitBufferParamsAPI.getWallTypes(params);
    return (
      res?.data?.map((item) => ({
        value: item.wall_type_name,
        label: item.wall_type_name,
      })) || []
    );
  } catch (e) {
    return [];
  }
};

export const getParamType = async () => {
  try {
    const res = await revitBufferParamsAPI.getParamType();
    const mappedData = res.data.map((item) => ({
      value: item.floor_param_type_id,
      label: item.floor_param_type_name,
    }));
    return mappedData;
  } catch (e) {
    return [];
  }
};

export const uploadRevitJson = async (body) => {
  try {
    const res = await revitBufferParamsAPI.uploadRevitJson(body);
    return res?.data;
  } catch (e) {
    return null;
  }
};

export const revitBufferParamsColumns = [
  {
    name: "index",
    field: "index",
    label: "№",
    align: "center",
  },
  {
    name: "floor_param_type_name",
    field: "floor_param_type_name",
    label: "Тип",
    align: "left",
  },
  {
    name: "floor_buffer_id",
    field: "floor_buffer_id",
    label: "floor_buffer_id",
    align: "center",
  },
  {
    name: "wall_type_name",
    field: "wall_type_name",
    label: "Тип стены",
    align: "left",
  },
  {
    name: "volume",
    field: "volume",
    label: "Объем",
    align: "right",
  },
  {
    name: "area",
    field: "area",
    label: "Площадь",
    align: "right",
  },
  {
    name: "height",
    field: "height",
    label: "Высота",
    align: "right",
  },
  {
    name: "wall_width",
    field: "wall_width",
    label: "Ширина стены",
    align: "right",
  },
  {
    name: "floor_field_1",
    field: "floor_field_1",
    label: "Этаж (Base Constraint)",
    align: "center",
  },
  {
    name: "floor_field_2",
    field: "floor_field_2",
    label: "Этаж (BiLevel)",
    align: "center",
  },
  {
    name: "param_geom",
    field: "param_geom",
    label: "Координаты",
    align: "left",
  },
  {
    name: "rowversion",
    field: "rowversion",
    label: "Дата создания",
    align: "center",
  },
  {
    name: "code",
    field: "code",
    label: "Код",
    align: "left",
  },
];
